import { render } from "./EditUsername.vue?vue&type=template&id=6b45ac38&scoped=true"
import script from "./EditUsername.vue?vue&type=script&lang=js"
export * from "./EditUsername.vue?vue&type=script&lang=js"

import "./EditUsername.vue?vue&type=style&index=0&id=6b45ac38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b45ac38"]])

export default __exports__